export const GA4_EVENT = Object.freeze({
  APP_OPEN: 'app_open',
  PAGE_VIEW: 'page_view',
  OFFER_VIEW: 'offer_view',
  SEARCH: 'search',
  FAVORITE_ADD: 'favorite_add',
  FAVORITE_REMOVE: 'favorite_remove',
  OPEN_MAPS: 'open_maps',
  LOGIN_PHONENUMBER: 'login_phonenumber',
  LOGIN_OTP: 'login_otp',
  LOGIN_SUCCESS: 'login_success',
});

